//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'ProfileOverviewSection',

    props: {
        isReady: {
          type: Boolean,
          default: false,
        },
        blockClass: {
        },
    },

    data() {
        return {
            visible: false,
        }
    },

    methods: {

        visibilityChanged(isVisible, entry) {
            if(isVisible) {
                this.$emit('visible')
                this.visible = true
            }
        },

    },

    computed: {

        showLoader() {

            if(this.visible === false) {
                return true
            }

            if(this.isReady === false) {
                return true
            }

            return false
        },

        bClass() {

            if(this.showLoader) {
                return ''
            }

            return this.blockClass

        },

    }

}

